/**
 * 内心独白组件
 */

import React from 'react';
import type { ChatMessage } from '../../../types';

interface ThoughtMessageProps {
  message: ChatMessage;
}

export const ThoughtMessage: React.FC<ThoughtMessageProps> = React.memo(({ message }) => (
  <div className="flex justify-center my-1">
    <span className="text-xs text-[#9B8EC4] italic text-center max-w-[85%]">
      {message.text}
    </span>
  </div>
));

ThoughtMessage.displayName = 'ThoughtMessage';
